import api from "./axios";

export const addPaymentApi = (id, data) =>
  api.post(`/leads/${id}/payments`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const deletePaymentApi = (leadId, paymentId) =>
  api.delete(`/leads/${leadId}/payments/${paymentId}`);
